export class ChessHistory {
    moves;
    currentMove;
    historyMove;
    initialPosition;
    initialPlayer;
    board;

    init(board) {
        this.board = board;
        this.moves = [];
        this.currentMove = -1;
        this.initialPlayer = board.currentPlayer;
        this.initialPosition = [];
        this.board.chessPieces.forEach(piece => {
            this.initialPosition.push(piece.clone());
        });
    }

    write(fromX, fromY, toX, toY) {
        this.currentMove++;
        if (this.currentMove < this.moves.length) {
            this.moves = this.moves.slice(0, this.currentMove);
        }
        this.moves.push({from: [fromX, fromY], to: [toX, toY]});
    }

    canUndo() {
        return this.currentMove > -1;
    }

    canRedo() {
        return this.currentMove < this.moves.length - 1;
    }

    undo() {
        if (this.currentMove > -1) {
            this.currentMove--;
            this.restorePosition();
        }
    }

    redo() {
        if (this.currentMove < this.moves.length - 1) {
            this.currentMove++;
            this.restorePosition();
        }
    }

    restorePosition() {
        const result = [];
        this.initialPosition.forEach(piece => {
            result.push(piece.clone());
        });
        this.board.chessPieces = result;
        this.board.currentPlayer = this.initialPlayer;

        for (let i = 0; i <= this.currentMove; i++) {
            this.historyMove = i;
            const move = this.moves[i];
            const piece = this.board.getPiece(move.from[0], move.from[1]);
            this.board.movePieceWithoutHistory(piece, move.to[0], move.to[1]);
        }
        this.historyMove = null;
    }

}